import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]

  connect() {
    // ページ読み込み後に合計を計算
    this.updateTotalHours()

    // フォーム送信時に非表示のフィールドを無効化
    const form = this.element.closest('form')
    if (form) {
      form.addEventListener('submit', this.handleSubmit.bind(this))
    }
  }

  handleSubmit() {
    // 現在非表示のコンテナのフィールドを無効化
    this.containerTargets.forEach(container => {
      const isHidden = window.getComputedStyle(container).display === 'none'
      if (isHidden) {
        // 非表示のコンテナ内のすべての入力フィールドを無効化
        const inputs = container.querySelectorAll('input, textarea, select')
        inputs.forEach(input => {
          input.disabled = true
        })
      }
    })
  }

  containerTargetConnected() {
    // コンテナが接続されたら合計を更新
    this.updateTotalHours()
  }

  addItem(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML('beforeend', content)
  }

  removeItem(event) {
    event.preventDefault()
    const item = event.target.closest('.work-report-item-fields')

    if (item.dataset.newRecord === "true") {
      item.remove()
    } else {
      item.style.display = 'none'
      const destroyField = item.querySelector("input[name*='_destroy']")
      if (destroyField) {
        destroyField.value = '1'
      }
    }

    this.updateTotalHours()
  }

  calculateHours(event) {
    const item = event.target.closest('.work-report-item-fields')

    const startTime = item.querySelector("input[name*='start_time']").value
    const endTime = item.querySelector("input[name*='end_time']").value
    const overnightCheckbox = item.querySelector("input[type='checkbox'][name*='overnight']")
    const breakHoursField = item.querySelector("input[name*='[break_hours]']")
    const hoursField = item.querySelector("input[name$='[hours]']")

    if (startTime && endTime) {
      const start = new Date(`2000-01-01T${startTime}`)
      let end = new Date(`2000-01-01T${endTime}`)

      // 翌日フラグがtrueの場合は24時間加算
      const isOvernight = overnightCheckbox && overnightCheckbox.checked
      if (isOvernight) {
        end = new Date(end.getTime() + 24 * 60 * 60 * 1000)
      }

      // 終了時刻が開始時刻より後であれば計算
      if (end > start) {
        const totalHours = (end - start) / (1000 * 60 * 60)
        const breakHours = parseFloat(breakHoursField.value) || 0
        const workHours = totalHours - breakHours
        hoursField.value = workHours > 0 ? workHours.toFixed(2) : '0.00'
      } else {
        // 翌日フラグなしで終了時刻が開始時刻以前の場合は0
        hoursField.value = '0.00'
      }
    }

    this.updateTotalHours()
  }

  updateTotalHours() {
    if (!this.hasContainerTarget) return

    let total = 0
    const items = this.containerTarget.querySelectorAll('.work-report-item-fields')

    items.forEach(item => {
      if (item.style.display !== 'none') {
        const hoursField = item.querySelector("input[name$='[hours]']")
        if (hoursField && hoursField.value) {
          total += parseFloat(hoursField.value) || 0
        }
      }
    })

    const totalElement = document.querySelector('[data-total-hours]')
    if (totalElement) {
      totalElement.textContent = total.toFixed(2)
    }
  }
}
